/* Temporizador de reserva del carrito */
(function () {
  if (customElements.get('cart-timer')) return;

  class CartTimer extends HTMLElement {
    connectedCallback() {
      this.clock = this.querySelector('[data-clock]');
      this.expired = this.querySelector('[data-expired]');
      this.textEl = this.querySelector('.af-ct__text');
      if (!this.clock) return;

      this.minutes = parseInt(this.dataset.minutes, 10) || 10;
      this.key = this.dataset.key || 'af-cart-timer';
      this.end = this.resolveEnd();
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    resolveEnd() {
      let end = NaN;
      try { end = parseInt(sessionStorage.getItem(this.key), 10); } catch (e) {}
      if (isNaN(end) || end <= Date.now()) {
        end = Date.now() + this.minutes * 60000;
        try { sessionStorage.setItem(this.key, String(end)); } catch (e) {}
      }
      return end;
    }

    tick() {
      const diff = this.end - Date.now();
      if (diff <= 0) {
        clearInterval(this.timer);
        if (this.textEl) this.textEl.hidden = true;
        if (this.expired) this.expired.hidden = false;
        return;
      }
      const s = Math.floor(diff / 1000);
      const m = Math.floor(s / 60);
      const sec = s % 60;
      this.clock.textContent = m + ':' + (sec < 10 ? '0' + sec : sec);
    }
  }

  customElements.define('cart-timer', CartTimer);
})();
